var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量导入快捷短语",
        visible: _vm.visibleProxy,
        width: "680px",
        "append-to-body": "",
        "custom-class": "fri-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        },
        closed: _vm.onClosed
      }
    },
    [
      _c(
        "div",
        { staticClass: "fri-row" },
        [
          _c("div", { staticClass: "fri-row-label" }, [
            _vm._v("选择覆盖方式：")
          ]),
          _vm._v(" "),
          _c(
            "el-radio-group",
            {
              staticClass: "fri-radio",
              model: {
                value: _vm.importType,
                callback: function($$v) {
                  _vm.importType = $$v
                },
                expression: "importType"
              }
            },
            [
              _c("el-radio", { attrs: { label: "increase" } }, [
                _vm._v("增量覆盖")
              ]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "override" } }, [
                _vm._v("全量覆盖")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fri-row" },
        [
          _c("div", { staticClass: "fri-row-label" }, [
            _vm._v("选择上传文件：")
          ]),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticClass: "fri-file",
            attrs: { type: "file", accept: ".csv,.txt,.xls,.xlsx" },
            on: { change: _vm.onFileChange }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "fri-upload-btn",
              attrs: { size: "small" },
              on: { click: _vm.chooseFile }
            },
            [_c("i", { staticClass: "el-icon-upload2" }), _vm._v(" 添加文件")]
          ),
          _vm._v(" "),
          _vm.fileName
            ? _c("div", { staticClass: "fri-file-name" }, [
                _vm._v(_vm._s(_vm.fileName))
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fri-tips" }, [
        _c("div", [
          _vm._v(
            "1、导入成功后会覆盖已添加内容，请谨慎操作（可先将现有内容导出）；"
          )
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("2、不同分组有不同的模板，需分别导入。")])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.visibleProxy = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.importLoading },
              on: { click: _vm.onImportClick }
            },
            [_vm._v("导入")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11b4bd37", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b4bd37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/FastReplyImportDDDialog.vue
// module id = 1747
// module chunks = 0